module.exports = __webpack_public_path__ + "img/1.bca81a6e.jpg";